import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { config } from "process";

@Injectable()
export class HomeService {
  api_url: string = environment.apiEndPoint;

  constructor(private http: HttpClient) {}

  getToken() {
    return localStorage.getItem(environment.TOKEN_SECRET);
  }

  geAllHomes() {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + "home",configs);
  }
  saveHomes(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    if (obj._id) {
      return this.http.put<any>(this.api_url + "home/" + obj._id, obj, configs);
    }
    return this.http.post<any>(this.api_url + "home", obj, configs);
  }
  deleteHome(obj) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
      body: obj,
    };
    return this.http.delete<any>(this.api_url + "home/" + obj._id, configs);
  }
//   getHome(job_id) {
//     return this.http.get<any>(this.api_url + "home/" + _id);
//   }
}



// WEBPACK FOOTER //
// ./src/app/home/home.service.ts